import { fieldState, toIntl } from "@/lib/content";
import { getLang, t } from "@/lib/i18n";

export const fmt = (s, vars = {}) => String(s).replace(/\{(\w+)\}/g, (_, k) => (vars[k] ?? ""));
export const tl = (n) => `${Number(n || 0).toLocaleString("tr-TR")} TL`;
export const trDate = (iso) => (iso ? iso.split("-").reverse().join(".") : "");
export const longDate = (iso) =>
  new Date(`${iso}T12:00:00`).toLocaleDateString(getLang() === "en" ? "en-GB" : "tr-TR", { weekday: "long", day: "numeric", month: "long", year: "numeric" });
export const amountOf = (prices, c, plate) => c.adult * (prices.adult || 0) + c.child * (prices.child || 0) + (plate ? prices.vehicle || 0 : 0);

const PLATE_RE = /^(0[1-9]|[1-7]\d|8[01])([A-Z]{1,3})(\d{2,5})$/;
export function normalizePlate(raw) {
  const s = raw.replace(/[ıiİ]/g, "I").toUpperCase().replace(/[\s.-]/g, "");
  const m = s.match(PLATE_RE);
  if (!m) return null;
  const [, city, l, d] = m;
  const ok = (l.length === 1 && d.length >= 4) || (l.length === 2 && (d.length === 3 || d.length === 4)) || (l.length === 3 && d.length <= 3);
  return ok ? `${city} ${l} ${d}` : null;
}

export const validPhone = (v) => /^90[2-5]\d{9}$/.test(toIntl(v));
export const validEmail = (v) => /^[^@\s]+@[^@\s]+\.[A-Za-z]{2,}$/.test(v.trim());

export function bookingLegal(content, isPreview) {
  return { kvkk: fieldState(content?.ticket_legal?.kvkk, isPreview), terms: fieldState(content?.ticket_legal?.terms, isPreview) };
}

// Live only when the server says so AND the legal texts are live in the current language
export function bookingVisible(site, content, isPreview) {
  if (isPreview) return true;
  if (!site?.booking_live) return false;
  const l = bookingLegal(content, false);
  return l.kvkk.show && l.terms.show;
}

export const errText = (code, cfg) => fmt(t(`bilet.errors.${code}`), { n: cfg?.max_persons });
